import React from 'react';

import CapRow from '../CapRow';
import CapImage from '../CapImage';
import L2Module from './L2Module';
import './_index.scss';
import { sortModulesByDisplayOrder, FormattedMessageWrapper, productLogoVctr } from './utils';
import CapHeading from '../CapHeading';
import CapDivider from '../CapDivider';

const SubModules = ({
  selectedL1ModuleObj,
  dispatchAction,
  handleRedirectionAndModuleSelection,
  l1_itemHovered,
  currentState,
  pushDataToGTM,
  redirectToLink,
}) => {
  const sortedSubModules = sortModulesByDisplayOrder(
    selectedL1ModuleObj?.subModules || [],
  );
  const { productLogo, name, displayLabel, hideHeadername } =
    selectedL1ModuleObj || {};

  return (
    <CapRow 
     className="sub-modules-padding" 
     onClick={(e) => e.stopPropagation()}
    >
      <CapRow type='flex' align="middle">
        <CapImage className="l2-product-logo" src={productLogoVctr[productLogo]} alt={"productLogo"}></CapImage>
        {!hideHeadername && 
          <>
            <CapDivider
              type="verticle"
              className='l2-product-divider'
            />
            <CapHeading type="h5" className='l2-product-name'>{<FormattedMessageWrapper id={displayLabel} message={name} />}</CapHeading>
          </>
        }
      </CapRow>
      <CapRow className="l2-items-container">
        {sortedSubModules?.map(
          subModule =>
            subModule?.isActive && subModule?.isVisible ? (
              <L2Module
                subModule={subModule}
                dispatchAction={dispatchAction}
                handleRedirectionAndModuleSelection={
                  handleRedirectionAndModuleSelection
                }
                l1_itemHovered={l1_itemHovered}
                pushDataToGTM={pushDataToGTM}
                redirectToLink={redirectToLink}
                currentState={currentState}
              />
            ) : (
              ''
            ),
        )}
      </CapRow>
    </CapRow>
  );
};

SubModules.defaultProps = {
  selectedL1ModuleObj: {},
  currentState: {},
  dispatchAction: () => {},
  handleRedirectionAndModuleSelection: () => {},
  redirectToLink: () => {},
  pushDataToGTM: () => {},
};
export default SubModules;
